import { globalAny, metadataTextSeparator } from "../../utils/Utils";
import { Image, TouchableOpacity } from "react-native";
import GenresComponent from "../../components/GenresComponent";
import Text from "../../components/Text/Text";
import { useEffect, useState } from "react";
import useToggleStore from "../../store/useToggle.store";
import {
	imageNarrow,
	imageWide,
	purchaseTitleNarrow,
	purchaseTitleWide,
	StyledDetails,
	StyledDetailsContainer,
	StyledMargin,
	StyledPackshotContainer,
	StyledPurchaseContainer,
	StyledText,
	StyledTextContainer,
	StyledTitle,
	StyledTitleContainer,
} from "./styled";
import { PurchaseProps } from "./models";

const PurchaseOptions = (props: PurchaseProps) => {
	const isToggleSKLegals = useToggleStore((state: any) => state.isToggleSKLegals);
	const wording = {
		purchasePrice: props.isRent ? globalAny.language.rent_price : globalAny.language.purchase_price,
		tax: props?.price?.taxType === 1 ? globalAny.language.tax : globalAny.language.vat,
		total: globalAny.language.total,
		termOfService: globalAny.language.purchase_agree,
	};

	const purchaseDetails = [
		{
			id: 1,
			title: wording.purchasePrice,
			price: props?.price?.price,
			bold: true,
		},
		{
			id: 2,
			title: `${wording.tax}`,
			price: props?.price?.taxAmount,
			bold: false,
			fontWeight: 400,
		},
		{
			id: 3,
			title: wording.total,
			price: props?.price?.totalAmount,
			bold: true,
		},
	];

	const [image, setImage] = useState();

	const getTermsText = () => {
		if (isToggleSKLegals) return `${globalAny.language.sk_legal_terms_text}\n\n${wording.termOfService}`;
		return wording.termOfService;
	};

	useEffect(() => {
		let getImage: any;
		if (props?.metadata?.packshots) {
			getImage = props?.metadata?.packshots?.filter((val: any) => val.width === 600 && val.height === 900)[0]?.url;
			setImage(getImage);
			return;
		}
		getImage = props?.metadata?.images?.filter((val: any) => val.width === 600 && val.height === 900)[0]?.url;
		setImage(getImage);
	}, []);

	const renderPurchaseDetails = (item: any) => (
		// @ts-ignores
		<StyledTextContainer key={`purchase-details-${item.id}`}>
			{/* @ts-ignore */}
			<StyledText bold={item.bold} fontWeight={item.fontWeight}>
				{item.title}
			</StyledText>
			{/* @ts-ignore */}
			<StyledText bold={item.bold} fontWeight={item.fontWeight}>
				{item.price}
			</StyledText>
		</StyledTextContainer>
	);

	return (
		//@ts-ignore
		<StyledPurchaseContainer isShow={props.show}>
			{/* @ts-ignore */}
			<StyledDetailsContainer>
				{/* @ts-ignore */}
				<StyledText>
					{/* @ts-ignore */}
					<StyledTitleContainer>
						{/* @ts-ignore */}
						<StyledTitle>
							<Text style={props.isNarrow ? purchaseTitleNarrow : purchaseTitleWide} numberOfLines={1} ellipsizeMode="tail">
								{props?.metadata?.title}
							</Text>
						</StyledTitle>

						{/* @ts-ignore */}
						<StyledDetails isNarrow={props.isNarrow}>
							<GenresComponent rating={props?.metadata?.rating} genres={props?.metadata?.genres} />
							<Text>{metadataTextSeparator(props?.metadata)}</Text>
						</StyledDetails>
					</StyledTitleContainer>
					{/* @ts-ignore */}
					<StyledMargin isNarrow={props.isNarrow}>
						{/* @ts-ignore */}
						{purchaseDetails.map((item) => {
							return renderPurchaseDetails({
								...item,
							});
						})}
					</StyledMargin>
					{/* @ts-ignore */}
					<StyledMargin>
						{/* @ts-ignore */}
						<StyledDetails isNarrow={props.isNarrow}>
							{/* @ts-ignore */}
							<StyledText fontWeight={400}>
								{getTermsText()}
								<TouchableOpacity onPress={props.onPressTermsAndService}>
									{/* @ts-ignore */}
									<StyledText fontWeight={400} underline={true}>
										{globalAny.language.terms_of_service}.
									</StyledText>
								</TouchableOpacity>
							</StyledText>
						</StyledDetails>
					</StyledMargin>
				</StyledText>
			</StyledDetailsContainer>
			{/* @ts-ignore */}
			<StyledPackshotContainer>
				<Image
					source={{
						uri: `${image}?width=600&disablewebp=false`,
					}}
					style={props.isNarrow ? imageNarrow : imageWide}
					resizeMode="cover"
				/>
			</StyledPackshotContainer>
		</StyledPurchaseContainer>
	);
};

export default PurchaseOptions;
